import { Amplify } from 'aws-amplify';
import awsmobile from './aws-exports';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import MainLayout from './components/Layout/MainLayout';
import Home from './pages/Home';
import SoundTransit from './pages/SoundTransit';
import Calendars from './pages/Calendars';
import Profile from './pages/Profile';
import Contact from './pages/Contact';
import Files from './pages/Files';
import theme from './theme';

Amplify.configure(awsmobile);

function App() {
  return (
    <Authenticator.Provider>
      <ThemeProvider theme={theme}>
        <Router>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/home" element={<Navigate to="/" replace />} />
              <Route path="/sound-transit" element={<SoundTransit />} />
              <Route path="/calendars" element={<Calendars />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/files" element={<Files />} />
              {/* Catch all route - redirect to home */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </MainLayout>
        </Router>
      </ThemeProvider>
    </Authenticator.Provider>
  );
}

export default App;
